import { Component, defineComponent } from 'vue';
import Disciplines from '@/presentation/disciplines/Disciplines.class';
import Discipline from './discipline/Discipline.vue';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	components: {
		Discipline: Discipline as Component,
	},
	setup: () => {

		const component = new Disciplines();
		return setupComponent(component);
	},
});